import type { ComponentType } from 'react';

import { withAlignment } from '@skyscanner/backpack-web/bpk-component-icon';
import BpkLargeCarsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/cars';
import BpkLargeFlightsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/flight';
import BpkLargeHotelsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels';
import BpkLargeTripsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/trips';
import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';
import BpkSectionList, {
  BpkSectionListItem,
} from '@skyscanner/backpack-web/bpk-component-section-list';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';
import {
  lineHeightXl,
  iconSizeLg,
} from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import type { I18nService } from '@shared/types/i18n';

import STYLE from './CrossLinks.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLE);

export type CrossLinksItem = {
  label: string;
  url: string;
  category: string;
};

export type Props = {
  items: CrossLinksItem[];
  i18n: I18nService;
};

const IconsMap: Record<string, ComponentType> = {
  'car-hire': BpkLargeCarsIcon,
  hotels: BpkLargeHotelsIcon,
  flights: BpkLargeFlightsIcon,
  flightsArrivalsDepartures: BpkLargeFlightsIcon,
  destinations: BpkLargeTripsIcon,
};

const CrossLinks = ({ i18n, items }: Props) => (
  <div className={cls('CrossLinks')}>
    <BpkSectionHeader
      title={i18n.translate('CrossLinks_HDP_title')}
      description={i18n.translate('CrossLinks_HDP_subtitle')}
    />
    <BpkSectionList>
      {items.map(({ category, label, url }) => {
        const Icon = withAlignment(
          IconsMap[category],
          lineHeightXl,
          iconSizeLg,
        );
        return (
          <BpkSectionListItem key={label} href={url}>
            <div className={cls('CrossLinks__label')}>
              <Icon className={cls('CrossLinks__icon')} />
              {label}
            </div>
          </BpkSectionListItem>
        );
      })}
    </BpkSectionList>
  </div>
);

export default withI18n(CrossLinks);
